/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams,
  GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidTraceability401,
  GetApiV1IndividualpaymentParcelsParcelidTraceability500,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentParcelsParcelidTraceability.ts";

function getGetApiV1IndividualpaymentParcelsParcelidTraceabilityUrl(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams["parcelId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/parcels/${parcelId}/traceability` as const,
  };
  return res;
}

/**
 * @description Retorna os registros de auditoria da parcela (GA_TRACEABILITY, entidade CourseFinPersonPayment). Com 'isBilletHistory=true' restringe aos campos relevantes do boleto (vencimento, multa, descontos, total). Migrado do legado IndividualPayment/LoadParcelTraceabilityGridDataAsync. **(Requer Authorization para autenticação)**
 * @summary Retorna a rastreabilidade (auditoria por campo) de uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/traceability}
 */
export async function getApiV1IndividualpaymentParcelsParcelidTraceability(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidTraceabilityPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentParcelsParcelidTraceabilityQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidTraceability401
      | GetApiV1IndividualpaymentParcelsParcelidTraceability500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentParcelsParcelidTraceabilityUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
